import React from 'react';

import { ZeosButton } from '../components/Shared/ZeosButton';
import { ZeosFileUpload } from '../components/Shared/ZeosFileUpload';
import { ZeosInput } from '../components/Shared/ZeosInput';
import { FileUploadDataType } from '../services/forms/DefaultFormData';

interface IProps {
  disabled?: boolean;
  errors: Record<string, string>;
  formData: FileUploadDataType;
  handleChange: (
    field: keyof FileUploadDataType
  ) => (e: React.ChangeEvent<HTMLInputElement>) => void;
  onCancel?: () => void;
  onSubmit?: () => void;
  setFormData: React.Dispatch<React.SetStateAction<FileUploadDataType>>;
  showAuthor?: boolean;
  showButtons?: boolean;
}

export const UploadImageForm = (props: IProps) => {
  const {
    formData,
    errors,
    handleChange,
    setFormData,
    onSubmit,
    onCancel,
    showButtons = true,
    showAuthor = false,
    disabled = false,
  } = props;

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (onSubmit) {
      onSubmit();
    }
  };

  return (
    <div className="bg-zeos-white-md p-4">
      <form
        className="p-4 bg-zeos-white shadow-sm border border-zeos-gray-light"
        onSubmit={handleSubmit}
      >
        <ZeosFileUpload
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          disabled={disabled}
        />
        <ZeosInput
          name="name"
          label="Name"
          placeholder="Enter Name"
          type="text"
          size="md"
          value={formData.name}
          onChange={handleChange("name")}
          error={errors.name}
          disabled={disabled}
        />
        {showAuthor && (
          <ZeosInput
            name="author"
            label="Author"
            placeholder="Enter Author"
            type="text"
            size="md"
            value={formData.author || ""}
            onChange={handleChange("author")}
            error={errors.author}
            disabled={disabled}
          />
        )}
        {showButtons && (
          <div className="mt-4 flex gap-2">
            <ZeosButton label="Upload" type="submit" mode="action" />
            <ZeosButton
              label="Cancel"
              type="button"
              mode="prev"
              onPress={onCancel}
            />
          </div>
        )}
      </form>
    </div>
  );
};
